import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import flagsmith from 'flagsmith';
import { LoginMiddleware } from './LoginMiddleware';
import { AppRouter } from './Router';
import createStore from '@/redux/config/configureStore';
import { queryClient } from '@/shared/config/queryClient';
import { env } from '@shared/config/env';
import { FlagsmithProvider } from 'flagsmith/react';
import { FlagsmithIdentifyOnUser } from '@shared/providers/FlagsmithIdentifyOnUser';
import { renderEmpty } from './utils/renderEmpty';
import { locale } from './utils/locale';

const store = createStore();

const flagsmithOptions = {
  api: env.FLAGSMITH_API_URL,
  environmentID: env.FLAGSMITH_ENVIRONMENT_ID,
};

// eslint-disable-next-line react/prop-types
export const App = () => {
  return (
    <Provider store={store}>
      <FlagsmithProvider flagsmith={flagsmith} options={flagsmithOptions}>
        <FlagsmithIdentifyOnUser>
          <QueryClientProvider client={queryClient}>
            <BrowserRouter>
              <ConfigProvider locale={locale} renderEmpty={renderEmpty}> {/* theme={{ token: { fontFamily: "'Montserrat', sans-serif" } }} */}
                <LoginMiddleware>
                  <AppRouter />
                </LoginMiddleware>
              </ConfigProvider>
            </BrowserRouter>
            <ReactQueryDevtools />
          </QueryClientProvider>
        </FlagsmithIdentifyOnUser>
      </FlagsmithProvider>
    </Provider>
  );
};